// extracted by mini-css-extract-plugin
module.exports = {"main":"cursorHoverMask_main__1umkG","mask":"cursorHoverMask_mask__lgHW3","body":"cursorHoverMask_body___iEiK"};